import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Medallion } from './Medallion';
import { brandName } from '../data/copy';
export function GuaranteeSection() {
  return <section className="defer-paint w-full bg-ink py-10 sm:py-14" aria-labelledby="guarantee-heading" data-id="element-123" data-mp="9ucrn7u79n36">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-124" data-mp="etft6iaz1b6e">
        <Medallion icon={ShieldCheckIcon} data-id="element-125" data-mp="eur02qzpqz1q" />

        <p className="mt-6 font-display text-base font-bold uppercase tracking-[0.22em] text-accent" data-id="element-126" data-mp="jssg131uei8z">
          7-day guarantee
        </p>
        <h2 id="guarantee-heading" className="mt-2 font-display text-[2.6rem] font-extrabold uppercase leading-none text-fg sm:text-6xl" data-id="element-127" data-mp="nst65kyb0hvv">
          100% protected
        </h2>

        <div className="mx-auto mt-7 max-w-prose space-y-4 text-lg leading-relaxed text-muted" data-id="element-128" data-mp="xk73pn6p37md">
          <p data-id="element-129" data-mp="12jtfds6vkft2">
            Access {brandName} and make sure you receive the 6 volumes and 5
            bonuses described on this page.
          </p>
          <p data-id="element-130" data-mp="17g0nnrmqu3e6">
            If a file is incomplete, you have an access problem, or the material
            delivered does not match the description of this offer, contact us
            within 7 days.
          </p>
          <p data-id="element-131" data-mp="20v6rfvi9pqbg">We will review the issue and work to solve it.</p>
          <p data-id="element-132" data-mp="1vu9d5u0dpgf8">
            If we cannot resolve it, you will receive a{' '}
            <span className="font-semibold text-fg" data-id="element-133" data-mp="1rt7cr9uq6ybo">full refund</span>.
          </p>
        </div>
        <p className="mt-8 font-display text-2xl font-extrabold uppercase text-accent" data-id="element-134" data-mp="2oioi1npsqicu">
          Zero unnecessary risk for you.
        </p>
      </div>
    </section>;
}